import React from "react";

const ReasonSummary = ({
  number,
  summary,
  text,
}: {
  number?: number;
  summary?: string;
  text?: string;
}) => {
  const htmltext = text ?? "";
  const label = String(number ?? "").padStart(2, "0");

  return (
    <div className="relative bg-white border-4 md:border-[8px] border-[#F6C544] rounded-[4px] md:rounded-[8px] text-left font-bold px-5 md:px-12 pt-8 md:pt-10 pb-5 md:pb-8 mb-4 md:mb-7 ml-5 md:ml-14 ">
      <div
        className="absolute -top-4 md:-top-7 -left-8 md:-left-[60px] w-14 h-14 md:w-[120px] md:h-[120px] rounded-full border-[8px] md:border-[16px] border-[#F6C544] bg-white text-[#F6C544] flex items-center justify-center  md:text-[40px] leading-none"
        style={{ fontFamily: '"Rounded Mplus 1c"' }}
      >
        {label}
      </div>
      <h3 className="pl-3 md:pl-10 text-[16px] md:text-[30px] leading-none text-black">
        {summary}
      </h3>
      <div className="h-[4px] md:h-[6px] max-w-[940px] mx-auto rounded-full bg-[#F6C544] mt-4 md:mt-6 mb-4 md:mb-5" />
      <div
        className="pl-3 md:pl-10 leading-[1.9]  text-[#2f2f2f] text-[13px] md:text-[24px] font-medium"
        dangerouslySetInnerHTML={{ __html: htmltext }}
      />
    </div>
  );
};

export default ReasonSummary;
